import { Component, HostBinding, HostListener, Inject } from "@angular/core";
import { MAT_SNACK_BAR_DATA, MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { MatIcon } from "@angular/material/icon";
import { NgClass } from "@angular/common";

@Component({
    selector: "cimsup-toaster",
    templateUrl: "toaster.component.html",
    styleUrls: ["toaster.component.scss"],
    standalone: true,
    imports: [NgClass, MatIcon],
})
export class ToasterComponent {
  level: string;
  message: string;
  messageMap: string;

  @HostBinding("class.clickable") goTo: string;

  @HostListener("click") onClick() {
    if (!this.goTo) return;
    this.router.navigate([this.goTo]);
    this.snackBarService.dismiss();
  }

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    private router: Router,
    private snackBarService: MatSnackBar
  ) {
    this.message = data.message;
    this.messageMap = data.messageMap;
    this.level = data.level;
    this.goTo = data.goTo;
  }

  getIcon(): string {
    switch (this.level) {
      case "error":
        return "warning";
      case "success":
        return "check-circle";
      case "info":
        return "info";
      default:
        return "info";
    }
  }

  getColor(): string {
    switch (this.level) {
      case "error":
        return "warn";
      case "success":
        return "accent";
      case "info":
        return "primary";
      default:
        return "";
    }
  }
}
